import React, { FC } from "react";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { Group, Stack, Text } from "@mantine/core";
import { MdOutlineFileUpload } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { HiOutlinePhoto } from "react-icons/hi2";

interface FileDropzoneProps {
  onDrop: (file: File) => void;
}

const FileDropzone: FC<FileDropzoneProps> = ({ onDrop }) => {
  return (
    <Dropzone.FullScreen
      active={true}
      accept={[
        MIME_TYPES.png,
        MIME_TYPES.jpeg,
        MIME_TYPES.svg,
        MIME_TYPES.gif,
        MIME_TYPES.pdf,
        MIME_TYPES.doc,
        MIME_TYPES.docx,
      ]}
      onDrop={(files) => {
        files.forEach((file) => {
          onDrop(file);
        });
      }}
    >
      <Group
        justify="center"
        align="center"
        gap="xl"
        mih={220}
        style={{ pointerEvents: "none" }}
        w="100vw"
      >
        <Dropzone.Accept>
          <MdOutlineFileUpload size={52} />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IoMdClose size={52} />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <HiOutlinePhoto size={52} />
        </Dropzone.Idle>

        <Stack>
          <Text size="xl" inline>
            Drag images here or click to select files
          </Text>
          <Text size="sm" c="dimmed" inline mt={7}>
            Attach as many files as you like, each file should not exceed 5mb
          </Text>
        </Stack>
      </Group>
    </Dropzone.FullScreen>
  );
};

export default FileDropzone;
